export const SPORTFREUNDE_BASE_URL = "https://sportfreunde-berlin.de/";
export const SPORTFREUNDE_BEITRAGSORDNUNG_URL = `${SPORTFREUNDE_BASE_URL}files/Sportfreunde%20Berlin%2006%20e.V.%20-%20Beitragsordnung.pdf`;
export const SPORTFREUNDE_SATZUNG_URL = `${SPORTFREUNDE_BASE_URL}files/Sportfreunde%20Berlin%2006%20e.V.%20-%20Satzung.pdf`;
